import { createGlobalStyle } from 'styled-components'

const fontsPath =
  process.env.NODE_ENV === 'production' ? '/digital/fonts' : '/fonts'

export default createGlobalStyle`
  :root {
    --primary-text: #001027;
    --secondary-text: #6b6b78;
    --paris-50: #652cdb;
    --background-light: #ebf2fe;

    --vila-olimpia-70: #6b6b78;
    --vila-olimpia-30: #d3d3e2;
    --vila-olimpia-20: #e6e6f0;
    --vila-olimpia-10: #f5f5fA;

    --buenos-aires-60: #1968c9;
    --buenos-aires-50: #4686d3;
    --buenos-aires-10: #e8eff9;

    --sao-paulo-60: #22766b;
    --sao-paulo-10: #D5EAE7;

    --white: #ffffff;

    --error: #C34E42;

    --vibin: #D8385E;
  }

  @font-dir: '/fonts';

  @font-face {
    font-family: "Lato";
    src: url('${fontsPath}/Lato/Lato-Regular.ttf');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: "Lato";
    src: url('${fontsPath}/Lato/Lato-Bold.ttf');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: "Lato";
    src: url('${fontsPath}/Lato/Lato-Black.ttf');
    font-weight: 900;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: "Lato";
    src: url('${fontsPath}/Lato/Lato-Light.ttf');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }


  @font-face {
    font-family: "Open Sans";
    src: url('${fontsPath}/OpenSans/OpenSans-Bold.ttf');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: "Open Sans";
    src: url('${fontsPath}/OpenSans/OpenSans-Light.ttf');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: "Open Sans";
    src: url('${fontsPath}/OpenSans/OpenSans-Regular.ttf');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
      font-family: "Rubik";
      src: url('${fontsPath}/Rubik/Rubik-Regular.ttf');
      font-weight: normal;
      font-style: normal;
      font-display: swap;
  }

  @font-face {
    font-family: "Rubik";
    src: url('${fontsPath}/Rubik/Rubik-Bold.ttf');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: "Rubik";
    src: url('${fontsPath}/Rubik/Rubik-Light.ttf');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: "Rubik";
    src: url('${fontsPath}/Rubik/Rubik-Medium.ttf');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  body, html {
    font-family: "Lato", "Helvetica Neue", "Rubik", "Open Sans", sans-serif;
    color: rgba(0, 0, 0, 0.87);
    margin: 0;
    padding: 0;
  }

  .grecaptcha-badge {
    display: none !important;
  }
`
